"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Spinner = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '35px' : _b, _c = _a.height, height = _c === void 0 ? '35px' : _c, _d = _a.strokeColor, strokeColor = _d === void 0 ? '#d63426' : _d, _e = _a.backgroundStrokeColor, backgroundStrokeColor = _e === void 0 ? '#d8d8d8' : _e, rest = __rest(_a, ["width", "height", "strokeColor", "backgroundStrokeColor"]);
    return (react_1["default"].createElement("svg", __assign({ width: width, height: height, viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid" }, rest),
        react_1["default"].createElement("circle", { cx: "50", cy: "50", r: "30", stroke: backgroundStrokeColor, strokeWidth: "10", fill: "none" }),
        react_1["default"].createElement("circle", { cx: "50", cy: "50", r: "30", stroke: strokeColor, strokeWidth: "8", strokeLinecap: "round", fill: "none" },
            react_1["default"].createElement("animateTransform", { attributeName: "transform", type: "rotate", repeatCount: "indefinite", dur: "1.4492753623188404s", values: "0 50 50;180 50 50;720 50 50", keyTimes: "0;0.5;1" }),
            react_1["default"].createElement("animate", { attributeName: "stroke-dasharray", repeatCount: "indefinite", dur: "1.4492753623188404s", values: "18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882", keyTimes: "0;0.5;1" }))));
};
exports["default"] = Spinner;
